import recentlyViewed from '../productclasspage/tes/recentlyviewed';

const $back = document.querySelector('.btnBack');

if($back){
    $back.addEventListener('click', () => window.history.back());
}

recentlyViewed.init();